import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'template', 'row']
  static values = { scope: String }

  connect() {
    if (this.rowTargets.length === 0) this.add()
  }

  add() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
  }

  remove(event) {
    event.target.closest('[data-key-value-rows-target="row"]').remove()
  }

  sync(event) {
    const row = event.target.closest('[data-key-value-rows-target="row"]')
    const key = event.target.value.trim()
    const valueInput = row.querySelector('[data-role="value"]')

    valueInput.name = key ? `${this.scopeValue}[${key}]` : ''
  }
}
